import { wrapLazyRoute } from "../lazy-loading/lazyWrapper";
export const routes = () => {
	return [
		{
			path: "/backoffice/personallists/create",
			component: wrapLazyRoute(() => import("ca_bo_ui/PersonallistsCsvUploadPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "personallistCreation",
			},
		},
		{
			path: "/backoffice/customer/search(/:redirect)",
			component: wrapLazyRoute(() => import("ca_bo_ui/CustomerSearchPage"), {
				usesBootstrap: true,
				usesMoment: true,
			}),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "empCustomerSearch",
			},
		},
		{
			path: "/backoffice/customer/restrictions",
			component: wrapLazyRoute(
				() =>
					import("ca_bo_ui/CustomerRestrictionsPage").then(m => ({
						default: m.CustomerRestrictionsPage,
					})),
				{
					usesBootstrap: true,
					usesMoment: true,
				},
			),
			routeParam: {
				noCustomerNeed: true,
				needsEmployee: true,
				trackingName: "empCustomerRestrictions",
			},
		},
	];
};
